import { GetterTree } from 'vuex'
import * as types from './types'

export default <GetterTree<contact.state.ContactState, RootState>>{
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: C O N T A C T : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    [types.CURRENT_CONTACT_ITEM](state) {
        return state.currentContactItem
    },

    [types.CONTACT_SELECTION](state) {
        return state.contacts.selections
    }
}
